import { render, staticRenderFns } from "./CustomerSuggestions.vue?vue&type=template&id=4fe56d6d&"
import script from "./CustomerSuggestions.vue?vue&type=script&lang=js&"
export * from "./CustomerSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSuggestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports